var modalSizeData = ['default', 'sm', 'lg', 'xl'];
export default modalSizeData;